export interface AboutContent {
  brandIntro: string;
  mission: string;
  vision: string;
  values: { title: string; description: string }[];
  milestones: { year: string; title: string; description: string }[];
  testimonials: { name: string; role: string; content: string; avatar: string }[];
  stats: { label: string; value: string; icon: string }[];
  contactInfo: {
    address: string;
    phone: string;
    email: string;
    workingHours: string;
  };
}

export const aboutData: AboutContent = {
  brandIntro: '红桃tv成立于2018年，是国内领先的高清视频娱乐平台。我们致力于为用户提供海量、优质、高清的视频内容，涵盖电视剧、电影、综艺、动漫、直播、纪录片、体育、少儿等多个品类。凭借先进的技术实力和丰富的内容储备，红桃tv已经成长为深受用户喜爱的视频娱乐品牌。',
  mission: '让每个人都能随时随地享受高品质视听娱乐，用内容连接世界，用科技传递快乐。',
  vision: '成为全球领先的数字娱乐内容平台，以创新科技驱动行业发展，为用户创造无限精彩的娱乐生活。',
  values: [
    { title: '用户至上', description: '始终把用户体验放在首位，持续优化产品，满足用户多元化的娱乐需求。' },
    { title: '内容为王', description: '坚持精品内容战略，严格把控内容质量，为用户提供有价值的视听体验。' },
    { title: '技术创新', description: '不断探索前沿技术，通过技术驱动产品升级，保持行业领先地位。' },
    { title: '合作共赢', description: '与内容创作者、版权方建立紧密合作关系，共同打造健康繁荣的内容生态。' },
  ],
  milestones: [
    { year: '2018', title: '平台创立', description: '红桃tv正式上线，以高清流畅的视频播放体验迅速获得用户认可。' },
    { year: '2019', title: '用户破千万', description: '注册用户突破1000万，内容库扩展至10万+小时。' },
    { year: '2020', title: '直播上线', description: '推出直播功能，覆盖体育赛事、电竞赛事等热门直播内容。' },
    { year: '2021', title: '4K全面升级', description: '全面支持4K超高清画质，成为行业画质标杆。' },
    { year: '2022', title: '用户破亿', description: '月活跃用户突破1亿，稳居行业第一梯队。' },
    { year: '2023', title: 'AI推荐系统', description: '上线自研AI智能推荐引擎，个性化推荐准确率提升40%。' },
    { year: '2024', title: '全球化布局', description: '启动国际化战略，内容覆盖东南亚、北美等海外市场。' },
    { year: '2025', title: '内容生态升级', description: '推出原创内容计划，投资制作多部头部IP作品，构建完整内容生态。' },
  ],
  testimonials: [
    {
      name: '张先生',
      role: '资深用户 · 使用红桃tv 5年',
      content: '从大学时代就开始用红桃tv追剧了。画质清晰不卡顿，资源更新也很快。现在全家都在用，已经是我们家不可或缺的娱乐工具了。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20business%20casual%20attire%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20warm%20lighting&width=200&height=200&seq=avatar-testimonial-01&orientation=squarish',
    },
    {
      name: '李女士',
      role: '影视爱好者 · 红桃tv忠实粉丝',
      content: '特别喜欢红桃tv的推荐功能，总能给我推荐到喜欢的剧。画质也是我用过所有平台里最好的，看大片体验特别棒！',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20with%20warm%20smile%2C%20modern%20office%20attire%2C%20clean%20studio%20lighting%2C%20friendly%20expression&width=200&height=200&seq=avatar-testimonial-02&orientation=squarish',
    },
    {
      name: '小王同学',
      role: '大学生 · 体育赛事迷',
      content: '作为一个体育迷，红桃tv的赛事直播真的太给力了！NBA、足球、电竞都有，画质清晰延迟低，看比赛的首选平台。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20college%20student%20portrait%20with%20casual%20style%2C%20energetic%20smile%2C%20clean%20background%2C%20modern%20youth%20vibe&width=200&height=200&seq=avatar-testimonial-03&orientation=squarish',
    },
  ],
  stats: [
    { label: '月活跃用户', value: '1.2亿+', icon: 'ri-user-star-line' },
    { label: '内容时长', value: '50万+小时', icon: 'ri-film-line' },
    { label: '覆盖品类', value: '8大品类', icon: 'ri-grid-line' },
    { label: '日均播放', value: '3.5亿次', icon: 'ri-play-circle-line' },
  ],
  contactInfo: {
    address: '北京市朝阳区望京科技园红桃大厦A座18层',
    phone: '400-888-6666',
    email: 'contact@hongtaotv.com',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};